const color = [
  "primary",
  "secondary",
  "success",
  "info",
  "warning",
  "error",
  "neutral",
  "unknown",
  "registered",
  "inProgress",
  "waitingForVerification",
  "workDone",
  "readyForInvoicing",
  "invoiced",
  "finished",
  "deleted",
  "cancelled"
] as const

const variant = [
  "solid",
  "outline",
  "soft",
  "subtle",
  "ghost",
  "link"
] as const

const size = [
  "xs",
  "sm",
  "md",
  "lg",
  "xl"
] as const

export default {
  "slots": {
    "base": [
      "rounded-md font-medium inline-flex items-center disabled:cursor-not-allowed aria-disabled:cursor-not-allowed disabled:opacity-75 aria-disabled:opacity-75",
      "transition-colors"
    ],
    "label": "truncate",
    "leadingIcon": "shrink-0",
    "leadingAvatar": "shrink-0",
    "leadingAvatarSize": "",
    "trailingIcon": "shrink-0"
  },
  "variants": {
    "fieldGroup": {
      "horizontal": "not-only:first:rounded-e-none not-only:last:rounded-s-none not-last:not-first:rounded-none focus-visible:z-[1]",
      "vertical": "not-only:first:rounded-b-none not-only:last:rounded-t-none not-last:not-first:rounded-none focus-visible:z-[1]"
    },
    "color": {
      "primary": "",
      "secondary": "",
      "success": "",
      "info": "",
      "warning": "",
      "error": "",
      "neutral": "",
      "unknown": "",
      "registered": "",
      "inProgress": "",
      "waitingForVerification": "",
      "workDone": "",
      "readyForInvoicing": "",
      "invoiced": "",
      "finished": "",
      "deleted": "",
      "cancelled": ""
    },
    "variant": {
      "solid": "",
      "outline": "",
      "soft": "",
      "subtle": "",
      "ghost": "",
      "link": ""
    },
    "size": {
      "xs": {
        "base": "px-2 py-1 text-xs gap-1",
        "leadingIcon": "size-4",
        "leadingAvatarSize": "3xs",
        "trailingIcon": "size-4"
      },
      "sm": {
        "base": "px-2.5 py-1.5 text-xs gap-1.5",
        "leadingIcon": "size-4",
        "leadingAvatarSize": "3xs",
        "trailingIcon": "size-4"
      },
      "md": {
        "base": "px-2.5 py-1.5 text-sm gap-1.5",
        "leadingIcon": "size-5",
        "leadingAvatarSize": "2xs",
        "trailingIcon": "size-5"
      },
      "lg": {
        "base": "px-3 py-2 text-sm gap-2",
        "leadingIcon": "size-5",
        "leadingAvatarSize": "2xs",
        "trailingIcon": "size-5"
      },
      "xl": {
        "base": "px-3 py-2 text-base gap-2",
        "leadingIcon": "size-6",
        "leadingAvatarSize": "xs",
        "trailingIcon": "size-6"
      }
    },
    "block": {
      "true": {
        "base": "w-full justify-center",
        "trailingIcon": "ms-auto"
      }
    },
    "square": {
      "true": ""
    },
    "leading": {
      "true": ""
    },
    "trailing": {
      "true": ""
    },
    "loading": {
      "true": ""
    },
    "active": {
      "true": {
        "base": ""
      },
      "false": {
        "base": ""
      }
    }
  },
  "compoundVariants": [
    {
      "color": "primary" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-primary hover:bg-primary/75 active:bg-primary/75 disabled:bg-primary aria-disabled:bg-primary outline-primary/25 focus-visible:outline-3"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-secondary hover:bg-secondary/75 active:bg-secondary/75 disabled:bg-secondary aria-disabled:bg-secondary outline-secondary/25 focus-visible:outline-3"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-success hover:bg-success/75 active:bg-success/75 disabled:bg-success aria-disabled:bg-success outline-success/25 focus-visible:outline-3"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-info hover:bg-info/75 active:bg-info/75 disabled:bg-info aria-disabled:bg-info outline-info/25 focus-visible:outline-3"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-warning hover:bg-warning/75 active:bg-warning/75 disabled:bg-warning aria-disabled:bg-warning outline-warning/25 focus-visible:outline-3"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-error hover:bg-error/75 active:bg-error/75 disabled:bg-error aria-disabled:bg-error outline-error/25 focus-visible:outline-3"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-neutral hover:bg-neutral/75 active:bg-neutral/75 disabled:bg-neutral aria-disabled:bg-neutral outline-neutral/25 focus-visible:outline-3"
    },
    {
      "color": "unknown" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-unknown hover:bg-unknown/75 active:bg-unknown/75 disabled:bg-unknown aria-disabled:bg-unknown outline-unknown/25 focus-visible:outline-3"
    },
    {
      "color": "registered" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-registered hover:bg-registered/75 active:bg-registered/75 disabled:bg-registered aria-disabled:bg-registered outline-registered/25 focus-visible:outline-3"
    },
    {
      "color": "inProgress" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-inProgress hover:bg-inProgress/75 active:bg-inProgress/75 disabled:bg-inProgress aria-disabled:bg-inProgress outline-inProgress/25 focus-visible:outline-3"
    },
    {
      "color": "waitingForVerification" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-waitingForVerification hover:bg-waitingForVerification/75 active:bg-waitingForVerification/75 disabled:bg-waitingForVerification aria-disabled:bg-waitingForVerification outline-waitingForVerification/25 focus-visible:outline-3"
    },
    {
      "color": "workDone" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-workDone hover:bg-workDone/75 active:bg-workDone/75 disabled:bg-workDone aria-disabled:bg-workDone outline-workDone/25 focus-visible:outline-3"
    },
    {
      "color": "readyForInvoicing" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-readyForInvoicing hover:bg-readyForInvoicing/75 active:bg-readyForInvoicing/75 disabled:bg-readyForInvoicing aria-disabled:bg-readyForInvoicing outline-readyForInvoicing/25 focus-visible:outline-3"
    },
    {
      "color": "invoiced" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-invoiced hover:bg-invoiced/75 active:bg-invoiced/75 disabled:bg-invoiced aria-disabled:bg-invoiced outline-invoiced/25 focus-visible:outline-3"
    },
    {
      "color": "finished" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-finished hover:bg-finished/75 active:bg-finished/75 disabled:bg-finished aria-disabled:bg-finished outline-finished/25 focus-visible:outline-3"
    },
    {
      "color": "deleted" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-deleted hover:bg-deleted/75 active:bg-deleted/75 disabled:bg-deleted aria-disabled:bg-deleted outline-deleted/25 focus-visible:outline-3"
    },
    {
      "color": "cancelled" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-cancelled hover:bg-cancelled/75 active:bg-cancelled/75 disabled:bg-cancelled aria-disabled:bg-cancelled outline-cancelled/25 focus-visible:outline-3"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-primary/50 text-primary hover:bg-primary/10 active:bg-primary/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-primary/25 focus-visible:outline-3 focus-visible:ring-primary"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-secondary/50 text-secondary hover:bg-secondary/10 active:bg-secondary/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-secondary/25 focus-visible:outline-3 focus-visible:ring-secondary"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-success/50 text-success hover:bg-success/10 active:bg-success/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-success/25 focus-visible:outline-3 focus-visible:ring-success"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-info/50 text-info hover:bg-info/10 active:bg-info/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-info/25 focus-visible:outline-3 focus-visible:ring-info"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-warning/50 text-warning hover:bg-warning/10 active:bg-warning/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-warning/25 focus-visible:outline-3 focus-visible:ring-warning"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-error/50 text-error hover:bg-error/10 active:bg-error/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-error/25 focus-visible:outline-3 focus-visible:ring-error"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-neutral/50 text-neutral hover:bg-neutral/10 active:bg-neutral/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-neutral/25 focus-visible:outline-3 focus-visible:ring-neutral"
    },
    {
      "color": "unknown" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-unknown/50 text-unknown hover:bg-unknown/10 active:bg-unknown/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-unknown/25 focus-visible:outline-3 focus-visible:ring-unknown"
    },
    {
      "color": "registered" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-registered/50 text-registered hover:bg-registered/10 active:bg-registered/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-registered/25 focus-visible:outline-3 focus-visible:ring-registered"
    },
    {
      "color": "inProgress" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-inProgress/50 text-inProgress hover:bg-inProgress/10 active:bg-inProgress/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-inProgress/25 focus-visible:outline-3 focus-visible:ring-inProgress"
    },
    {
      "color": "waitingForVerification" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-waitingForVerification/50 text-waitingForVerification hover:bg-waitingForVerification/10 active:bg-waitingForVerification/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-waitingForVerification/25 focus-visible:outline-3 focus-visible:ring-waitingForVerification"
    },
    {
      "color": "workDone" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-workDone/50 text-workDone hover:bg-workDone/10 active:bg-workDone/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-workDone/25 focus-visible:outline-3 focus-visible:ring-workDone"
    },
    {
      "color": "readyForInvoicing" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-readyForInvoicing/50 text-readyForInvoicing hover:bg-readyForInvoicing/10 active:bg-readyForInvoicing/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-readyForInvoicing/25 focus-visible:outline-3 focus-visible:ring-readyForInvoicing"
    },
    {
      "color": "invoiced" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-invoiced/50 text-invoiced hover:bg-invoiced/10 active:bg-invoiced/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-invoiced/25 focus-visible:outline-3 focus-visible:ring-invoiced"
    },
    {
      "color": "finished" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-finished/50 text-finished hover:bg-finished/10 active:bg-finished/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-finished/25 focus-visible:outline-3 focus-visible:ring-finished"
    },
    {
      "color": "deleted" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-deleted/50 text-deleted hover:bg-deleted/10 active:bg-deleted/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-deleted/25 focus-visible:outline-3 focus-visible:ring-deleted"
    },
    {
      "color": "cancelled" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-cancelled/50 text-cancelled hover:bg-cancelled/10 active:bg-cancelled/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-cancelled/25 focus-visible:outline-3 focus-visible:ring-cancelled"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-primary bg-primary/10 hover:bg-primary/15 active:bg-primary/15 outline-primary/25 focus-visible:outline-3 disabled:bg-primary/10 aria-disabled:bg-primary/10"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-secondary bg-secondary/10 hover:bg-secondary/15 active:bg-secondary/15 outline-secondary/25 focus-visible:outline-3 disabled:bg-secondary/10 aria-disabled:bg-secondary/10"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-success bg-success/10 hover:bg-success/15 active:bg-success/15 outline-success/25 focus-visible:outline-3 disabled:bg-success/10 aria-disabled:bg-success/10"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-info bg-info/10 hover:bg-info/15 active:bg-info/15 outline-info/25 focus-visible:outline-3 disabled:bg-info/10 aria-disabled:bg-info/10"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-warning bg-warning/10 hover:bg-warning/15 active:bg-warning/15 outline-warning/25 focus-visible:outline-3 disabled:bg-warning/10 aria-disabled:bg-warning/10"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-error bg-error/10 hover:bg-error/15 active:bg-error/15 outline-error/25 focus-visible:outline-3 disabled:bg-error/10 aria-disabled:bg-error/10"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-neutral bg-neutral/10 hover:bg-neutral/15 active:bg-neutral/15 outline-neutral/25 focus-visible:outline-3 disabled:bg-neutral/10 aria-disabled:bg-neutral/10"
    },
    {
      "color": "unknown" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-unknown bg-unknown/10 hover:bg-unknown/15 active:bg-unknown/15 outline-unknown/25 focus-visible:outline-3 disabled:bg-unknown/10 aria-disabled:bg-unknown/10"
    },
    {
      "color": "registered" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-registered bg-registered/10 hover:bg-registered/15 active:bg-registered/15 outline-registered/25 focus-visible:outline-3 disabled:bg-registered/10 aria-disabled:bg-registered/10"
    },
    {
      "color": "inProgress" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-inProgress bg-inProgress/10 hover:bg-inProgress/15 active:bg-inProgress/15 outline-inProgress/25 focus-visible:outline-3 disabled:bg-inProgress/10 aria-disabled:bg-inProgress/10"
    },
    {
      "color": "waitingForVerification" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-waitingForVerification bg-waitingForVerification/10 hover:bg-waitingForVerification/15 active:bg-waitingForVerification/15 outline-waitingForVerification/25 focus-visible:outline-3 disabled:bg-waitingForVerification/10 aria-disabled:bg-waitingForVerification/10"
    },
    {
      "color": "workDone" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-workDone bg-workDone/10 hover:bg-workDone/15 active:bg-workDone/15 outline-workDone/25 focus-visible:outline-3 disabled:bg-workDone/10 aria-disabled:bg-workDone/10"
    },
    {
      "color": "readyForInvoicing" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-readyForInvoicing bg-readyForInvoicing/10 hover:bg-readyForInvoicing/15 active:bg-readyForInvoicing/15 outline-readyForInvoicing/25 focus-visible:outline-3 disabled:bg-readyForInvoicing/10 aria-disabled:bg-readyForInvoicing/10"
    },
    {
      "color": "invoiced" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-invoiced bg-invoiced/10 hover:bg-invoiced/15 active:bg-invoiced/15 outline-invoiced/25 focus-visible:outline-3 disabled:bg-invoiced/10 aria-disabled:bg-invoiced/10"
    },
    {
      "color": "finished" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-finished bg-finished/10 hover:bg-finished/15 active:bg-finished/15 outline-finished/25 focus-visible:outline-3 disabled:bg-finished/10 aria-disabled:bg-finished/10"
    },
    {
      "color": "deleted" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-deleted bg-deleted/10 hover:bg-deleted/15 active:bg-deleted/15 outline-deleted/25 focus-visible:outline-3 disabled:bg-deleted/10 aria-disabled:bg-deleted/10"
    },
    {
      "color": "cancelled" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-cancelled bg-cancelled/10 hover:bg-cancelled/15 active:bg-cancelled/15 outline-cancelled/25 focus-visible:outline-3 disabled:bg-cancelled/10 aria-disabled:bg-cancelled/10"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-primary ring ring-inset ring-primary/25 bg-primary/10 hover:bg-primary/15 active:bg-primary/15 disabled:bg-primary/10 aria-disabled:bg-primary/10 outline-primary/25 focus-visible:outline-3 focus-visible:ring-primary"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-secondary ring ring-inset ring-secondary/25 bg-secondary/10 hover:bg-secondary/15 active:bg-secondary/15 disabled:bg-secondary/10 aria-disabled:bg-secondary/10 outline-secondary/25 focus-visible:outline-3 focus-visible:ring-secondary"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-success ring ring-inset ring-success/25 bg-success/10 hover:bg-success/15 active:bg-success/15 disabled:bg-success/10 aria-disabled:bg-success/10 outline-success/25 focus-visible:outline-3 focus-visible:ring-success"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-info ring ring-inset ring-info/25 bg-info/10 hover:bg-info/15 active:bg-info/15 disabled:bg-info/10 aria-disabled:bg-info/10 outline-info/25 focus-visible:outline-3 focus-visible:ring-info"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-warning ring ring-inset ring-warning/25 bg-warning/10 hover:bg-warning/15 active:bg-warning/15 disabled:bg-warning/10 aria-disabled:bg-warning/10 outline-warning/25 focus-visible:outline-3 focus-visible:ring-warning"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-error ring ring-inset ring-error/25 bg-error/10 hover:bg-error/15 active:bg-error/15 disabled:bg-error/10 aria-disabled:bg-error/10 outline-error/25 focus-visible:outline-3 focus-visible:ring-error"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-neutral ring ring-inset ring-neutral/25 bg-neutral/10 hover:bg-neutral/15 active:bg-neutral/15 disabled:bg-neutral/10 aria-disabled:bg-neutral/10 outline-neutral/25 focus-visible:outline-3 focus-visible:ring-neutral"
    },
    {
      "color": "unknown" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-unknown ring ring-inset ring-unknown/25 bg-unknown/10 hover:bg-unknown/15 active:bg-unknown/15 disabled:bg-unknown/10 aria-disabled:bg-unknown/10 outline-unknown/25 focus-visible:outline-3 focus-visible:ring-unknown"
    },
    {
      "color": "registered" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-registered ring ring-inset ring-registered/25 bg-registered/10 hover:bg-registered/15 active:bg-registered/15 disabled:bg-registered/10 aria-disabled:bg-registered/10 outline-registered/25 focus-visible:outline-3 focus-visible:ring-registered"
    },
    {
      "color": "inProgress" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-inProgress ring ring-inset ring-inProgress/25 bg-inProgress/10 hover:bg-inProgress/15 active:bg-inProgress/15 disabled:bg-inProgress/10 aria-disabled:bg-inProgress/10 outline-inProgress/25 focus-visible:outline-3 focus-visible:ring-inProgress"
    },
    {
      "color": "waitingForVerification" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-waitingForVerification ring ring-inset ring-waitingForVerification/25 bg-waitingForVerification/10 hover:bg-waitingForVerification/15 active:bg-waitingForVerification/15 disabled:bg-waitingForVerification/10 aria-disabled:bg-waitingForVerification/10 outline-waitingForVerification/25 focus-visible:outline-3 focus-visible:ring-waitingForVerification"
    },
    {
      "color": "workDone" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-workDone ring ring-inset ring-workDone/25 bg-workDone/10 hover:bg-workDone/15 active:bg-workDone/15 disabled:bg-workDone/10 aria-disabled:bg-workDone/10 outline-workDone/25 focus-visible:outline-3 focus-visible:ring-workDone"
    },
    {
      "color": "readyForInvoicing" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-readyForInvoicing ring ring-inset ring-readyForInvoicing/25 bg-readyForInvoicing/10 hover:bg-readyForInvoicing/15 active:bg-readyForInvoicing/15 disabled:bg-readyForInvoicing/10 aria-disabled:bg-readyForInvoicing/10 outline-readyForInvoicing/25 focus-visible:outline-3 focus-visible:ring-readyForInvoicing"
    },
    {
      "color": "invoiced" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-invoiced ring ring-inset ring-invoiced/25 bg-invoiced/10 hover:bg-invoiced/15 active:bg-invoiced/15 disabled:bg-invoiced/10 aria-disabled:bg-invoiced/10 outline-invoiced/25 focus-visible:outline-3 focus-visible:ring-invoiced"
    },
    {
      "color": "finished" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-finished ring ring-inset ring-finished/25 bg-finished/10 hover:bg-finished/15 active:bg-finished/15 disabled:bg-finished/10 aria-disabled:bg-finished/10 outline-finished/25 focus-visible:outline-3 focus-visible:ring-finished"
    },
    {
      "color": "deleted" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-deleted ring ring-inset ring-deleted/25 bg-deleted/10 hover:bg-deleted/15 active:bg-deleted/15 disabled:bg-deleted/10 aria-disabled:bg-deleted/10 outline-deleted/25 focus-visible:outline-3 focus-visible:ring-deleted"
    },
    {
      "color": "cancelled" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-cancelled ring ring-inset ring-cancelled/25 bg-cancelled/10 hover:bg-cancelled/15 active:bg-cancelled/15 disabled:bg-cancelled/10 aria-disabled:bg-cancelled/10 outline-cancelled/25 focus-visible:outline-3 focus-visible:ring-cancelled"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-primary hover:bg-primary/10 active:bg-primary/10 outline-primary/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-secondary hover:bg-secondary/10 active:bg-secondary/10 outline-secondary/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-success hover:bg-success/10 active:bg-success/10 outline-success/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-info hover:bg-info/10 active:bg-info/10 outline-info/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-warning hover:bg-warning/10 active:bg-warning/10 outline-warning/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-error hover:bg-error/10 active:bg-error/10 outline-error/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-neutral hover:bg-neutral/10 active:bg-neutral/10 outline-neutral/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "unknown" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-unknown hover:bg-unknown/10 active:bg-unknown/10 outline-unknown/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "registered" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-registered hover:bg-registered/10 active:bg-registered/10 outline-registered/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "inProgress" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-inProgress hover:bg-inProgress/10 active:bg-inProgress/10 outline-inProgress/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "waitingForVerification" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-waitingForVerification hover:bg-waitingForVerification/10 active:bg-waitingForVerification/10 outline-waitingForVerification/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "workDone" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-workDone hover:bg-workDone/10 active:bg-workDone/10 outline-workDone/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "readyForInvoicing" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-readyForInvoicing hover:bg-readyForInvoicing/10 active:bg-readyForInvoicing/10 outline-readyForInvoicing/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "invoiced" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-invoiced hover:bg-invoiced/10 active:bg-invoiced/10 outline-invoiced/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "finished" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-finished hover:bg-finished/10 active:bg-finished/10 outline-finished/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "deleted" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-deleted hover:bg-deleted/10 active:bg-deleted/10 outline-deleted/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "cancelled" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-cancelled hover:bg-cancelled/10 active:bg-cancelled/10 outline-cancelled/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-primary hover:text-primary/75 active:text-primary/75 disabled:text-primary aria-disabled:text-primary outline-primary/25 focus-visible:outline-3"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-secondary hover:text-secondary/75 active:text-secondary/75 disabled:text-secondary aria-disabled:text-secondary outline-secondary/25 focus-visible:outline-3"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-success hover:text-success/75 active:text-success/75 disabled:text-success aria-disabled:text-success outline-success/25 focus-visible:outline-3"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-info hover:text-info/75 active:text-info/75 disabled:text-info aria-disabled:text-info outline-info/25 focus-visible:outline-3"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-warning hover:text-warning/75 active:text-warning/75 disabled:text-warning aria-disabled:text-warning outline-warning/25 focus-visible:outline-3"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-error hover:text-error/75 active:text-error/75 disabled:text-error aria-disabled:text-error outline-error/25 focus-visible:outline-3"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-neutral hover:text-neutral/75 active:text-neutral/75 disabled:text-neutral aria-disabled:text-neutral outline-neutral/25 focus-visible:outline-3"
    },
    {
      "color": "unknown" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-unknown hover:text-unknown/75 active:text-unknown/75 disabled:text-unknown aria-disabled:text-unknown outline-unknown/25 focus-visible:outline-3"
    },
    {
      "color": "registered" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-registered hover:text-registered/75 active:text-registered/75 disabled:text-registered aria-disabled:text-registered outline-registered/25 focus-visible:outline-3"
    },
    {
      "color": "inProgress" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-inProgress hover:text-inProgress/75 active:text-inProgress/75 disabled:text-inProgress aria-disabled:text-inProgress outline-inProgress/25 focus-visible:outline-3"
    },
    {
      "color": "waitingForVerification" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-waitingForVerification hover:text-waitingForVerification/75 active:text-waitingForVerification/75 disabled:text-waitingForVerification aria-disabled:text-waitingForVerification outline-waitingForVerification/25 focus-visible:outline-3"
    },
    {
      "color": "workDone" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-workDone hover:text-workDone/75 active:text-workDone/75 disabled:text-workDone aria-disabled:text-workDone outline-workDone/25 focus-visible:outline-3"
    },
    {
      "color": "readyForInvoicing" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-readyForInvoicing hover:text-readyForInvoicing/75 active:text-readyForInvoicing/75 disabled:text-readyForInvoicing aria-disabled:text-readyForInvoicing outline-readyForInvoicing/25 focus-visible:outline-3"
    },
    {
      "color": "invoiced" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-invoiced hover:text-invoiced/75 active:text-invoiced/75 disabled:text-invoiced aria-disabled:text-invoiced outline-invoiced/25 focus-visible:outline-3"
    },
    {
      "color": "finished" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-finished hover:text-finished/75 active:text-finished/75 disabled:text-finished aria-disabled:text-finished outline-finished/25 focus-visible:outline-3"
    },
    {
      "color": "deleted" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-deleted hover:text-deleted/75 active:text-deleted/75 disabled:text-deleted aria-disabled:text-deleted outline-deleted/25 focus-visible:outline-3"
    },
    {
      "color": "cancelled" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-cancelled hover:text-cancelled/75 active:text-cancelled/75 disabled:text-cancelled aria-disabled:text-cancelled outline-cancelled/25 focus-visible:outline-3"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-inverted hover:bg-inverted/90 active:bg-inverted/90 disabled:bg-inverted aria-disabled:bg-inverted outline-inverted/25 focus-visible:outline-3"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-accented text-default bg-default hover:bg-elevated active:bg-elevated disabled:bg-default aria-disabled:bg-default outline-inverted/25 focus-visible:outline-3 focus-visible:ring-inverted"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-default bg-elevated hover:bg-accented/75 active:bg-accented/75 outline-inverted/25 focus-visible:outline-3 disabled:bg-elevated aria-disabled:bg-elevated"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "ring ring-inset ring-accented text-default bg-elevated hover:bg-accented/75 active:bg-accented/75 disabled:bg-elevated aria-disabled:bg-elevated outline-inverted/25 focus-visible:outline-3 focus-visible:ring-inverted"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-default hover:bg-elevated active:bg-elevated outline-inverted/25 focus-visible:outline-3 hover:disabled:bg-transparent dark:hover:disabled:bg-transparent hover:aria-disabled:bg-transparent dark:hover:aria-disabled:bg-transparent"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-muted hover:text-default active:text-default disabled:text-muted aria-disabled:text-muted outline-inverted/25 focus-visible:outline-3"
    },
    {
      "size": "xs" as typeof size[number],
      "square": true,
      "class": "p-1"
    },
    {
      "size": "sm" as typeof size[number],
      "square": true,
      "class": "p-1.5"
    },
    {
      "size": "md" as typeof size[number],
      "square": true,
      "class": "p-1.5"
    },
    {
      "size": "lg" as typeof size[number],
      "square": true,
      "class": "p-2"
    },
    {
      "size": "xl" as typeof size[number],
      "square": true,
      "class": "p-2"
    },
    {
      "loading": true,
      "leading": true,
      "class": {
        "leadingIcon": "animate-spin"
      }
    },
    {
      "loading": true,
      "leading": false,
      "trailing": true,
      "class": {
        "trailingIcon": "animate-spin"
      }
    }
  ],
  "defaultVariants": {
    "color": "primary" as typeof color[number],
    "variant": "solid" as typeof variant[number],
    "size": "md" as typeof size[number]
  }
}